module.exports = [{
      plugin: require('../../../plugins/gatsby-powergo-brp-smartsite-theme/gatsby-browser.js'),
      options: {"plugins":[],"instockToken":"34d74628a296a850460a57f19ba9d9c38c961642","sourceEnv":"production","websiteDomain":"www.lanteignesports.com"},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
